export const handleChangeDataAddCourierPage = (name, value) => ({
    type: 'CHANGE_DATA_PAGE_ADD_COURIER', name, value
});